export const HTS_TOKEN_ID = '0.0.7118319';
export const HTS_TOKEN_NAME = 'Hotel Booking NFT';
export const HTS_TOKEN_TREASURY = '0.0.7054981';


